import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { UtilService } from '../../../../core/services/util/util.service';

@Component({
  selector: 'app-claim-detail-dialog',
  templateUrl: './claim-detail-dialog.component.html',
  styleUrl: './claim-detail-dialog.component.css'
})
export class ClaimDetailDialogComponent {
  @Input('open')
  open: boolean = false;
  @Input('detail')
  detail: any = {};
  @Output('callBackClaimDetail')
  callBackPromotionDetail: EventEmitter<object> = new EventEmitter<object>();

  faChevronLeft = faChevronLeft;

  constructor(
    private utilService: UtilService
  ) { }

  close() {
    this.callBackPromotionDetail.emit({ followUp: false })
  }

  followUp() {
    this.callBackPromotionDetail.emit({ followUp: true, serial_no: this.detail.product ? this.detail.product.serial_no : null })
  }

  dateFormat(date: number) {
    return this.utilService.dayjs(date).format('DD/MM/YYYY, HH:mm')
  }

  displayStatus(status: string, is_receipt: any, is_delivery: boolean) {
    /**
      S1 =	ส่ง SUP
      S2 =	ส่งช่าง
      S3 =	รอสินค้า (Remax)
      S4 =	รอสินค้า (ซัพนอก)
      S5 =	รอดำเนินการ
      S6 =	ปิดงาน
      S7 =	อื่นๆ
    */

    if (status === 'ปิดงาน') {
      if (is_delivery) {
        return 'จัดส่งให้ลูกค้าแล้ว'
      } else {
        if (is_receipt) {
          return 'รับเข้าแล้ว'
        } else {
          return 'รอร้านค้ารับเข้า'
        }
      }
    }
    return status
  }

  colorStatus(status: string, is_receipt: any, is_delivery: boolean) {
    /**
      S1 =	ส่ง SUP
      S2 =	ส่งช่าง
      S3 =	รอสินค้า (Remax)
      S4 =	รอสินค้า (ซัพนอก)
      S5 =	รอดำเนินการ
      S6 =	ปิดงาน
      S7 =	อื่นๆ
    */

    if (status === 'ปิดงาน') {
      if (is_delivery) {
        return '!bg-lime-200'
      } else {
        if (is_receipt) {
          return '!bg-lime-200'
        } else {
          return '!bg-orange-300'
        }
      }
    } else {
      return 'bg-yellow-200'
    }
  }

}
